import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronRight, ChevronLeft, Star, Quote } from "lucide-react";

export default function Testimonials({ items }) {
  const [idx, setIdx] = useState(0);
  if (!items?.length) return null;
  const t = items[idx];
  const next = () => setIdx((i) => (i + 1) % items.length);
  const prev = () => setIdx((i) => (i - 1 + items.length) % items.length);

  return (
    <div className="relative mx-auto max-w-4xl" data-testid="testimonials-slider">
      <Quote size={64} className="absolute -top-6 right-0 text-gold/15" />
      <AnimatePresence mode="wait">
        <motion.figure
          key={idx}
          initial={{ opacity: 0, x: -40 }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: 40 }}
          transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
          className="glass-panel relative rounded-3xl border border-gold/20 p-8 sm:p-10"
          data-testid="testimonial-card"
        >
          <div className="mb-5 flex gap-1">
            {Array.from({ length: t.rating }).map((_, i) => (
              <Star key={i} size={16} className="fill-gold text-gold" />
            ))}
          </div>
          <blockquote className="text-lg leading-loose text-slate-200 sm:text-xl">«{t.quote}»</blockquote>
          <figcaption className="mt-6 flex flex-wrap items-center gap-3 text-sm">
            <span className="font-display font-bold text-gold" data-testid="testimonial-name">{t.name}</span>
            <span className="rounded-full bg-navy-700 px-3 py-1 text-xs text-slate-300">{t.country}</span>
            <span className="rounded-full bg-navy-700 px-3 py-1 text-xs text-slate-300">{t.visaType}</span>
            <span className="ms-auto text-xs text-slate-500">{t.date}</span>
          </figcaption>
        </motion.figure>
      </AnimatePresence>

      <div className="mt-6 flex items-center justify-between">
        <div className="flex gap-2">
          {items.map((_, i) => (
            <button key={i} onClick={() => setIdx(i)} aria-label={`نظر ${i + 1}`} className={`h-2 rounded-full transition-all duration-300 ${i === idx ? "w-8 bg-gold" : "w-2 bg-slate-600 hover:bg-slate-500"}`} data-testid={`testimonial-dot-${i + 1}`} />
          ))}
        </div>
        <div className="flex gap-3">
          <button onClick={prev} className="flex h-11 w-11 items-center justify-center rounded-full border border-gold/25 text-gold transition-colors hover:bg-gold/10" aria-label="قبلی" data-testid="testimonial-prev-button">
            <ChevronRight size={18} />
          </button>
          <button onClick={next} className="flex h-11 w-11 items-center justify-center rounded-full border border-gold/25 text-gold transition-colors hover:bg-gold/10" aria-label="بعدی" data-testid="testimonial-next-button">
            <ChevronLeft size={18} />
          </button>
        </div>
      </div>
    </div>
  );
}
